// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"fe982120","762":"f2bd667d"}[chunkId] + ".chunk.css";
};